class SyncUtils {
  constructor() { }

  /**
   * Hack para aguardar sincronia de template.
   * Apesar do tempo estar parametrizado, se for necessário adicionar
   * qualquer valor acima de 10 provavelmente esse hack não esta resolvendo. 
   * @param {Function} fn Função para executar após sincronia
   * @param {Number} time Tempo em MS para aguardar sincronia.
   */
  aguardaSincronia(fn = () => {}, time = 1) {
    setTimeout(fn,time);
  }
}

export const syncUtils = new SyncUtils()